import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faInstagram, 
  faXTwitter, 
  faFacebook, 
  faLinkedin,
  faTelegram
} from "@fortawesome/free-brands-svg-icons";
import './index.css';

const SocialMediaIcons = memo(() => {
  const socialLinks = [
    { 
      href: "https://www.instagram.com/angeltwinai/", 
      icon: faInstagram,
      label: "Instagram" 
    },
    { 
      href: "https://x.com/ANGL_Token", 
      icon: faXTwitter,
      label: "X (Twitter)" 
    },
    { 
      href: "https://www.facebook.com/profile.php?id=61572536822828", 
      icon: faFacebook,
      label: "Facebook" 
    },
    { 
      href: "https://www.linkedin.com/company/angel-twin-ai", 
      icon: faLinkedin,
      label: "LinkedIn" 
    },
    { 
      href: "https://t.me/angeltwinsai", 
      icon: faTelegram,
      label: "Telegram" 
    }
  ];

  return (
    <div className="angl-social-icons">
      {socialLinks.map((social, index) => (
        <a 
          key={index} 
          href={social.href} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="angl-social-icon"
          aria-label={social.label}
        >
          <FontAwesomeIcon icon={social.icon} />
        </a>
      ))}
    </div>
  );
});

export default SocialMediaIcons;